import { useContext } from 'react';
import { createContext } from 'react';
import { Skeleton } from '../skeleton';

type KeyValueRowProps = {
  label: string;
  value: React.ReactNode;
  isLoading?: boolean;
};

export const KeyValueRow = ({
  label,
  value,
  isLoading: individualLoading,
}: KeyValueRowProps) => {
  const { isLoading: contextLoading } = useKeyValueRow();
  // ใช้ค่า loading จาก prop ก่อน ถ้าไม่มีจะใช้จาก context
  const isLoading = individualLoading ?? contextLoading;

  return (
    <div className="grid grid-cols-6">
      <span className="col-span-1 text-muted-foreground">{label}</span>
      <div className="col-span-5">
        {isLoading ? <Skeleton className="h-4 w-32" /> : value}
      </div>
    </div>
  );
};

type KeyValueRowContextType = {
  isLoading?: boolean;
};

const KeyValueRowContext = createContext<KeyValueRowContextType>({
  isLoading: false,
});

export const KeyValueRowProvider = ({
  children,
  isLoading = false,
}: {
  children: React.ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <KeyValueRowContext.Provider value={{ isLoading }}>
      {children}
    </KeyValueRowContext.Provider>
  );
};

export const useKeyValueRow = () => useContext(KeyValueRowContext);
